import type { ColumnFilterOptionItem } from '@/lib/table/types';

/** The backend's sortable whitelist (`DRIVER_SORT_FIELDS`); a `sortBy` outside it 400s. Location and assignment are deliberately not sortable. */
export const DRIVER_SORT_KEYS = [
  'firstName',
  'lastName',
  'employeeId',
  'email',
  'phone',
  'mobile',
  'department',
  'costCenter',
  'status',
] as const;

/** Not static: Location is tenant-scoped and limited to values actually used by current drivers (see `useDriverFilterOptions`). */
export interface DriverColumnFilterOptions {
  locations: ColumnFilterOptionItem[];
  /** The number plates actually assigned to the tenant's current drivers. */
  plates: ColumnFilterOptionItem[];
}
